import { render, staticRenderFns } from "./TradeAddGift.vue?vue&type=template&id=226e7906&scoped=true&"
import script from "./TradeAddGift.vue?vue&type=script&lang=js&"
export * from "./TradeAddGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e7906",
  null
  
)

export default component.exports